import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';


const LazyDocuments = lazy(() => import('./Documents'));

export const Documents: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyDocuments {...props} />
	</Suspense>
);
